'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var _Joi$string;
var linkTypes = ['apple_music', 'apple_podcasts', 'cash_app', 'discord', 'email', 'etsy', 'facebook', 'github', 'google', 'instagram', 'linkedin', 'pinterest', 'snapchat', 'spotify', 'threads', 'tiktok', 'twitch', 'twitter', 'venmo', 'website', 'youtube', 'standard'];
var LandingPageLinkClick = Joi__default["default"].object().keys({
  form_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).required().allow(null).description('The id of the landing page in Hype Forms table'),
  theme_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).optional().allow(null).description('The id of the theme applied'),
  link_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).required().allow(null).description('The id of the link in Hype SocialLinks or Links table'),
  link_url: Joi__default["default"].string().uri({
    allowRelative: false
  }).description('URL of link'),
  link_social_type: Joi__default["default"].alternatives().conditional('link_type', {
    is: 'social',
    then: (_Joi$string = Joi__default["default"].string()).valid.apply(_Joi$string, linkTypes).description('Specific social platform for link, or standard')
  }),
  link_type: Joi__default["default"].string().valid('social', 'link_block').required().description('Type of link, either social or for a link block'),
  link_title: Joi__default["default"].string().optional().description('Title for link if link_block'),
  link_description: Joi__default["default"].string().allow(null).optional().description('Description for link if link_block')
}).description('landing_page:link_click event attributes ').meta({
  name: 'LandingPageLinkClick',
  filename: 'landing_page:link_click.model'
});
var LandingPageLinkClick$1 = LandingPageLinkClick;

module.exports = LandingPageLinkClick$1;
//# sourceMappingURL=link_click.model.js.map
